import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

export const FormGrowthMarketingPlaybook = () => {
  const [state, setState] = useState({
    send: false,
    name: "",
    phone: "",
    email: "",
    role: "",
    site: "",
    goal: "",
    validate: false,
  });

  const [phoneMaskMode, setPhoneMaskMode] = useState(0);

  const validationName = () => {
    let valid = false;
    const input = state.name;
    if (!!input) {
      valid = !!input && input.length > 1 && input.length < 50 && input.indexOf("@") === -1;
    }
    return valid;
  };

  const validationPhone = () => {
    let valid = false;
    const regex = new RegExp("^[^A-zА-я]{5,}");
    const input = state.phone;
    if (!!input) {
      valid = !!input && regex.test(input) && input.length < 50;
    }
    return valid;
  };

  const validationEmail = () => {
    let valid = false;
    const regex = new RegExp(
      "^[a-zA-Zа-яёА-ЯЁ0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Zа-яёА-ЯЁ0-9](?:[a-zA-Zа-яёА-ЯЁ0-9-]{0,61}[a-zA-Zа-яёА-ЯЁ0-9])?(?:.[a-zA-Zа-яёА-ЯЁ0-9](?:[a-zA-Zа-яёА-ЯЁ0-9-]{0,61}[a-zA-Zа-яёА-ЯЁ0-9])?)*$",
    );
    const input = state.email;
    if (!!input) {
      valid = !!input && regex.test(input) && input.length < 50;
    }
    return valid;
  };

  const validationSite = () => {
    let valid = false;
    let expression =
      /((?:www\.|(?!www))[a-zA-Zа-яёА-ЯЁ0-9][a-zA-Zа-яёА-ЯЁ0-9-]+[a-zA-Zа-яёА-ЯЁ0-9]\.[^\s]{2,}|www\.[a-zA-Zа-яёА-ЯЁ0-9][a-zA-Zа-яёА-ЯЁ0-9-]+[a-zA-Zа-яёА-ЯЁ0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Zа-яёА-ЯЁ0-9]+\.[^\s]{2,}|www\.[a-zA-Zа-яёА-ЯЁ0-9]+\.[^\s]{2,})/gi;
    const regex = new RegExp(expression);
    const input = state.site;
    if (!!input) {
      valid = !!input && regex.test(input) && input.length < 50;
    }
    return valid;
  };

  const phoneMask = (value: string) => {
    if (
      ((value.charAt(0) === "7" || value.charAt(0) === "8") && phoneMaskMode === 0 && value.length === 1) ||
      (value.charAt(1) === "7" && phoneMaskMode === 0 && value.length === 2)
    ) {
      setPhoneMaskMode(1);
      return "+7 (";
    } else if (value.charAt(3) === "(" && value.length === 7 && phoneMaskMode === 1) {
      setPhoneMaskMode(2);
      return value + ") ";
    } else if (
      (value.length === 12 || value.length === 15) &&
      value.charAt(0) === "+" &&
      value.charAt(1) === "7" &&
      phoneMaskMode === 2
    ) {
      setPhoneMaskMode(1);
      return value + "-";
    } else if (value.length > 2 && value.length < 7) {
      setPhoneMaskMode(1);
      return value;
    } else if (value.length > 10) {
      setPhoneMaskMode(2);
      return value;
    } else {
      // Пользователь всё стёр
      if (value === "") {
        setPhoneMaskMode(0);
      }
      return value;
    }
  };

  // Form update
  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      validate: validationName() && validationPhone() && validationEmail() && validationSite(),
    }));
  }, [state.name, state.phone, state.email, state.goal, state.site]);

  const handleChange = (event: any) => {
    const target = event.target;
    const value = target.name === "phone" ? phoneMask(target.value) : target.value;
    const name = target.name;

    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (event: any) => {
    const newState = { ...state, send: true };
    setState(newState);

    // Отправка данных в Dashly
    let demoEvent = "Download 41 growth marketing campaign template";
    let demoTrack = {
      Ads: "",
      Заголовок: "Growth marketing playbook",
      Имя: state.name,
      Телефон: state.phone,
      Email: state.email.toLowerCase(),
      // Должность: state.role,
      Сайт: state.site,
      Цель: state.goal,
      type: "form",
      url: window.location.host + window.location.pathname,
    };
    let identifyData = [
      { op: "update_or_create", key: "$name", value: state.name },
      { op: "update_or_create", key: "$phone", value: state.phone },
      { op: "update_or_create", key: "$email", value: state.email.toLowerCase() },
      { op: "update_or_create", key: "Адрес сайта", value: state.site },
      { op: "update_or_create", key: "Цель", value: state.goal },
      { op: "update_or_create", key: "Источник заявки", value: window.location.host + window.location.pathname },
    ];

    if (window.location.search !== "") {
      let adsText = decodeURIComponent(window.location.search);
      identifyData.push({
        op: "update_or_create",
        key: "Реклама и тд",
        value: adsText,
      });

      demoTrack = {
        ...demoTrack,
        Ads: adsText,
      };
    }

    carrotquest.identify(identifyData);
    carrotquest.track(demoEvent, demoTrack);

    event.preventDefault();
  };

  return (
    <div className="ConsultationForm">
      {/* Форма для сбора данных  */}
      <Form onSubmit={handleSubmit} className={state.send ? "w-100 mt-4 hide" : "w-100 mt-4"}>
        <Row className="TakeMe gx-4">
          {/* Name */}
          <Col md="6" className="mb-4">
            <Form.Group className="TakeMe__group">
              <Form.Label htmlFor="name" className="font12px lightgrey-text">
                Name
              </Form.Label>
              <Form.Control
                value={state.name}
                onChange={handleChange}
                placeholder="Name"
                isInvalid={!validationName()}
                id="name"
                name="name"
                type="text"
                required
                autoComplete="on"
                className="px-4 py-2"
              />
            </Form.Group>
          </Col>

          {/* Email */}
          <Col md="6" className="mb-4">
            <Form.Group className="TakeMe__group">
              <Form.Label htmlFor="email" className="font12px lightgrey-text">
                Business email
              </Form.Label>
              <Form.Control
                value={state.email}
                onChange={handleChange}
                placeholder="Business email"
                isInvalid={!validationEmail()}
                id="email"
                name="email"
                type="email"
                required
                autoComplete="on"
                className="px-4 py-2"
              />
            </Form.Group>
          </Col>

          {/* Site */}
          <Col md="6" className="mb-4">
            <Form.Group className="TakeMe__group">
              <Form.Label htmlFor="site" className="font12px lightgrey-text">
                Company website
              </Form.Label>
              <Form.Control
                value={state.site}
                onChange={handleChange}
                placeholder="Company website"
                isInvalid={!validationSite()}
                id="site"
                name="site"
                type="text"
                required
                autoComplete="on"
                className="px-4 py-2"
              />
            </Form.Group>
          </Col>

          {/* Phone */}
          <Col md="6" className="mb-4">
            <Form.Group className="TakeMe__group">
              <Form.Label htmlFor="phone" className="font12px lightgrey-text">
                Phone number
              </Form.Label>
              <Form.Control
                value={state.phone}
                onChange={handleChange}
                placeholder="Phone number"
                isInvalid={!validationPhone()}
                id="phone"
                name="phone"
                type="text"
                required
                autoComplete="on"
                className="px-4 py-2"
              />
            </Form.Group>
          </Col>

          {/* Goal */}
          <Col md="6" className="mb-4">
            <Form.Group className="TakeMe__group">
              <Form.Select
                value={state.goal}
                onChange={handleChange}
                placeholder="What's your current goal?"
                id="goal"
                name="goal"
                required
                autoComplete="on"
                className="px-4 py-2"
              >
                <option value="" disabled selected>
                  What's your current goal?
                </option>
                <option>Generate more leads</option>
                <option>Convert more leads into buyers</option>
                <option>Provide customer support</option>
                <option>Cut costs on current services</option>
                <option>To start email communications</option>
                <option>Something else</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Button */}
          <Col md="6">
            <Form.Group className="mb-0">
              <Button type="submit" variant="primary" disabled={!state.validate} className="w-100 px-4 py-2">
                Get the playbook
              </Button>
            </Form.Group>
          </Col>
        </Row>
      </Form>

      {/* Текст после отправки  */}
      {state.send && (
        <div className="afterSend row align-items-center">
          <div>
            <div className="h3 mb-3">Thanks a lot, we just emailed you the playbook!</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormGrowthMarketingPlaybook;
